"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuStyle = void 0;
var styled_components_1 = require("styled-components");
exports.useMenuStyle = function () {
    var theme = styled_components_1.useTheme();
    return {
        '&&': {
            '.button-dropdown-footer button:last-child': {
                backgroundColor: theme.colors.datePicker.apply,
                border: "1px solid " + theme.colors.datePicker.apply,
                ':hover, :active, :focus-visible': {
                    backgroundColor: theme.colors.datePicker.applyDark,
                },
                ':focus-visible': {
                    outline: "1px solid " + theme.colors.datePicker.applyOutline,
                },
            },
            '.react-calendar__tile--active': {
                background: theme.colors.datePicker.tileLight,
            },
            '.react-calendar__tile--rangeStart, .react-calendar__tile--rangeEnd': {
                background: theme.colors.datePicker.tileDark,
            },
            '.react-calendar__tile--hasActive, .react-calendar__tile--active, .react-calendar__tile--rangeStart, .react-calendar__tile--rangeEnd': {
                '&:focus, &:hover': {
                    background: theme.colors.datePicker.tileDark,
                },
            },
        },
    };
};
